import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import {
    Google,
    GoogleTransformers,
    Pixall,
    PixallTransformers,
} from 'reaxl-analytics-handlers';

import getInventoryOwnerById from '@/analytics/utilities/getInventoryOwnerById';
import { isVDP } from '@/analytics/utilities/isVDP';

const { DataLayerTransformer } = PixallTransformers;
const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

export function ownerEmailConfirmationNextStepsClick({
    event,
}, option) {
    const ctaLabel = (event?.target?.innerText || event?.target?.textContent || '').trim();
    const linkCopy = _kebabCase(ctaLabel);

    Google.sendClickEvent({
        eventElement: 'partner',
        eventResult: `text-link::fake-door::${linkCopy}`,
        eventNonInteractive: true,
    }, option);

    return { linkCopy };
}

/**
 * @summary Sends event when email subcribe button is clicked
 * @data cardType
 */
export function ownerEmailSubcribeClick({
    data = {},
    state,
    dataLayer,
}, option) {
    const { inventoryId } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const listingType = _get(inventory, 'listingType', '').toLowerCase();
    const eventResult = 'cta::alert::subcribe::email';
    const pageName = DataLayerTransformer.getPageName(dataLayer);

    Google.sendClickEvent({
        eventElement: `vdp_${listingType}`,
        eventResult,
        eventData: {
            vehicle: googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }),
        },
    }, option);

    Pixall.sendClickEvent({
        eventSource: 'button',
        eventType: 'click',
        pageType: 'vdp',
        label: eventResult,
        inventory,
        pixallData: {
            clickTypeToListingType: pageName === 'vdp',
        },
    }, dataLayer, option);

    // return data for custom event
    return { cmp: eventResult };
}

export function emailFormEngagementClick({ dataLayer, state, data }, option = {}) {
    const {
        inventoryId,
        uiContext = 'default',
    } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const listingType = _get(inventory, 'listingType', '').toLowerCase();

    let placement;
    switch (uiContext) {
        case 'ownerDetails':
            placement = 'dealer-card';
            break;

        case 'multi':
            placement = 'nba';
            break;

        case 'calculator':
        case 'compareSendOffer':
            placement = 'nds';
            break;

        case 'compare':
            placement = 'compare';
            break;

        case 'mediaGallery':
            placement = 'media-gallery';
            break;

        case 'quote':
            placement = 'new-car-custom-order';
            break;

        case 'additionalProtections':
            placement = 'additional-protection-modal';
            break;

        case 'virtualTour':
        case 'vehicleDelivery':
        case 'testDrive':
            placement = 'dhs';
            break;

        default:
            placement = 'inline';
    }

    Pixall.sendClickEvent({
        label: `email-field-engagement:${placement}`,
        inventory,
        eventSource: 'application',
        abTestId: DataLayerTransformer.getPageAttributes(dataLayer)?.abTestId,
        pixallData: {
            clickTypeToListingType: isVDP(dataLayer),
        },
    }, dataLayer, option);

    Google.sendClickEvent({
        eventResult: `email-field-engagement::${placement}`,
        eventElement: `vdp_${listingType}`,
        eventNonInteractive: false,
        eventData: {
            vehicle: {
                ...googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }),
            },
        },
    }, option);

    return {};
}

export default {
    emailFormEngagementClick,
    ownerEmailConfirmationNextStepsClick,
    ownerEmailSubcribeClick,
};
